import { initHints } from './utils/hintsFactory';

const STORAGE_VERSION = 'v1';
const STORAGE_NAME = `rsim-products`;

const INITIAL_VALUES = {
  accounts: [],
  productCodes: [],
  tags: [],
  connectionId: [],
  orderNumber: [],
  mobileNetworkOperator: [],
} as {
  accounts: string[];
  productCodes: any[];
  tags: any[];
  connectionId: any[];
  orderNumber: any[];
  mobileNetworkOperator: any[];
};
// #TODO: add types

const { storageAtom, syncAtom, updateAllAtom, gettersAndRemovers } = initHints({
  storageName: STORAGE_NAME,
  storageVersion: STORAGE_VERSION,
  initialValues: INITIAL_VALUES,
});

const { accounts, productCodes, tags, connectionId, orderNumber, mobileNetworkOperator } =
  gettersAndRemovers;

export const atomWithStorage = storageAtom;

export const syncHintsAtom = syncAtom;
export const updateHintsAtom = updateAllAtom;
export const accountsHintsAtom = accounts;
export const productCodesHintsAtom = productCodes;
export const tagsHintsAtom = tags;
export const connectionIdHintsAtom = connectionId;
export const orderNumberHintsAtom = orderNumber;
export const rsimMnoHintsAtom = mobileNetworkOperator;
